/**
 * app.config.js — APP IDENTITY & AUTH CONFIG
 *
 * AICX Canvases: the nine canvases and the Case Card for the two-day executive course
 * "AI-Powered Customer Experience (AICX)". Two portals: Learner (registers, fills in, exports)
 * and Facilitator (sees the cohort).
 */

export const APP_CONFIG = {
  name: 'AICX Canvases',
  tagline: 'Fill in your nine canvases and your Case Card, one step at a time, and take the finished pack away as a PDF.',
  emoji: '🧭',
  icon: 'Compass',

  defaultTheme: 'system',
  defaultLoginRoute: '/learner/login',
};

export const AUTH_PROFILES = [
  {
    key: 'learner',
    name: 'Learner_c',
    label: 'Learner',
    profileSlug: '',
    redirectAfterAuth: '/dashboard',
    hasSignup: true,
    reportsTo: 'Facilitator_c',
    authPage: {
      loginTitle: 'Sign in to your canvases',
      signupTitle: 'Register for the AICX canvases',
      loginDescription: 'Pick up exactly where you left off. Everything you typed is saved.',
      signupDescription: 'Register with your name, email and a password. You add your organisation the first time you sign in.',
    },
    altLinksLeadIn: 'Running the workshop?',
    altLinks: [{ href: '/facilitator/login', label: 'Sign in as a Facilitator' }],
  },
  {
    key: 'facilitator',
    name: 'Facilitator_c',
    label: 'Facilitator',
    profileSlug: '',
    redirectAfterAuth: '/cohort',
    hasSignup: false,
    reportsTo: null,
    authPage: {
      loginTitle: 'Facilitator sign in',
      signupTitle: 'Facilitator account',
      loginDescription: 'See how your cohort is getting on with the canvases.',
      signupDescription: null,
    },
    altLinksLeadIn: 'Taking the course?',
    altLinks: [{ href: '/learner/login', label: 'Sign in as a Learner' }],
  },
];

export const GENERIC_AUTH = {
  loginTitle: 'Welcome back',
  signupTitle: 'Create account',
  loginDescription: null,
  signupDescription: null,
  redirectAfterAuth: '/dashboard',
};
